const Styles = {
    main: {
        background: '#F5F8EC 0% 0% no-repeat padding-box',
        boxShadow: '0px 0px 25px rgba(0,0,0,0.16)',
        border: '2px solid #D1E8A4',
        minHeight: 102,
        maxHeight: 128,
        padding: '40px 0px',
        position: 'absolute',
        width: '100%',
        zIndex: 100,
        boxSizing: 'border-box'
    },
    mainError: {
        background: '#FCF1F2 0% 0% no-repeat padding-box',
        boxShadow: '0px 0px 25px rgba(0,0,0,0.16)',
        border: '2px solid #EEA7AD',
        minHeight: 102,
        maxHeight: 128,
        padding: '40px 0px',
        position: 'absolute',
        width: '100%',
        zIndex: 100,
        boxSizing: 'border-box'
    },
    message: {
        font: '600 16px/20px benton-sans',
        color: 'rgb(73, 73, 74)',
        margin: 0,
        display: 'inline-block',
        paddingLeft: 15/* ,
        height: 19 */
    },
    info: {
        font: '500 16px/20px benton-sans',
        color: 'rgb(73, 73, 74)',
        display: 'inline-block',
        marginTop: 10,
        marginBottom: 0,
        paddingLeft: 15,
        height: 19
    },
    container: {
        position: 'relative',
        boxSizing: 'border-box'
    },
    time: {
        position: 'absolute',
        right: '92px',
        top: 4,
        display: 'inline-block',
        font: '600 14px/20px benton-sans'
    },
    timer1: {
        position: 'absolute',
        top: 11,
        right: 0,        
    },
    timer2: {
        position: 'absolute',
        top: -4,
        right: 0
    },
    crossAfter: {
        width: '16px',
        transform: 'rotate(45deg)',
        border: '1.5px solid rgb(73, 73, 74)',
        position: 'absolute',
        left: '15px',
        top: '22px',
        borderRadius: '3px',
        backgroundColor: 'rgb(73, 73, 74)'
    },
    crossBefore: {
        width: '16px',
        height: '0',
        transform: 'rotate(-45deg)',
        border: '1.5px solid rgb(73, 73, 74)',
        position: 'absolute',
        left: '15px',
        top: '22px',
        borderRadius: '2px',
        backgroundColor: 'rgb(73, 73, 74)'
    },
    closeButton: {
        backgroundColor: 'transparent',
        display: 'inline-block',
        width: '50px',
        height: '50px',
        border: '1.5px solid rgb(73, 73, 74)',
        borderRadius: '50%',
        position: 'absolute',
        right: 25,
        top: -12
    },
    relative: {
        position: 'relative'
    },
    margin: {
        margin: '0'
    },
};

export default Styles;